module.exports = __webpack_public_path__ + "img/insurance.30a2f79e.svg";